import { redirect, useParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetOptionListPageParams = (): { hotelID: string } => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.OPTION.TOP>>();

	if (!hotelID) {
		redirect("/");
	}

	return { hotelID: hotelID! };
};
